import { GameLogger } from "@/game/utils/gameLogger";

export function initializeTelegramWebApp(): void {
  try {
    // Check if running in Telegram WebApp environment
    const telegram = (window as any).Telegram;
    if (!telegram?.WebApp) {
      GameLogger.logInfo("TelegramUtils", "Not running in Telegram WebApp environment");
      return;
    }

    const webApp = telegram.WebApp;

    // Initialize Telegram WebApp
    webApp.ready();
    webApp.requestFullscreen();
    webApp.disableVerticalSwipes();

    // Attempt orientation lock when landscape detected (best effort)
    const tryLockLandscape = () => {
      if (window.matchMedia("(orientation: landscape) and (max-width: 768px)").matches) {
        try {
          // Use optional chaining in case lockOrientation doesn't exist
          webApp.lockOrientation?.();

          // Check if it actually worked
          if (webApp.isOrientationLocked) {
            GameLogger.logInfo("TelegramUtils", "Successfully locked to landscape orientation");
          } else {
            GameLogger.logInfo("TelegramUtils", "lockOrientation called but not locked");
          }
        } catch (error) {
          GameLogger.logError("TelegramUtils", "Failed to lock orientation:", error);
        }
      }
    };

    // Try to lock on initialization
    tryLockLandscape();

    // Listen for orientation changes
    window.addEventListener("orientationchange", tryLockLandscape);

    GameLogger.logInfo(
      "TelegramUtils",
      "Telegram WebApp initialized: fullscreen and landscape mode requested"
    );
  } catch (error) {
    GameLogger.logError("TelegramUtils", "Error initializing Telegram WebApp:", error);
  }
}
